import { httpClient } from '@bcba/client-auth';
import { CommonStorageFacilitySerializer } from '@bcba/serializers';

export const getStorageFacilities = async () => {
  const { data } = await httpClient.get<CommonStorageFacilitySerializer[]>(
    '/storage-facilities',
  );
  return data;
};
